import React, { FC, useRef } from "react";
import type { P2pMoneyAbroadHeroProps } from "@/types";
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";
import { Image } from "../image";
import { useResponsiveVideoSource } from "../../hooks";

export const P2pMoneyAbroadHero: FC<P2pMoneyAbroadHeroProps> = ({
  title,
  description,
  heroImage
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  const videoRef = useRef<HTMLVideoElement>(null);
  useResponsiveVideoSource(videoRef, {
    desktopSrc: "/video/home-hero-desktop.mp4",
    mobileSrc: "/video/home-hero-mobile.mp4",
  });

  return (
    <section className="p2pMoneyAbroadHero">
      <div className="wrapper">
        <div className="p2pMoneyAbroadHero--inner">
          <div ref={ref} className="p2pMoneyAbroadHero--content">
            <SplitTextAnimation
              htmlElement={
                <h1
                  style={{
                    opacity: isInView ? 1 : 0,
                  }}
                >
                  {title}
                </h1>
              }
              isInView={isInView}
              className="p2pMoneyAbroadHero--title"
            />
            
          </div>
          <div className="p2pMoneyAbroadHero--description-content">
            <ContentManager
              content={description}
              className="p2pMoneyAbroadHero--description"
            />
          </div>  
          <div className="p2pMoneyAbroadHero--quote">
            {heroImage.file?.url && (
              <Image
                src={heroImage as any}
                alt={heroImage.title}
                className={`quote-image`}
            />   
          )}
          </div>
          <div className="p2pMoneyAbroadHero--visual">
            {/* Single <video> with media-scoped sources so only the matching
                file downloads (see components/home/hero.tsx). */}
            <video
              ref={videoRef}
              muted
              autoPlay
              loop
              playsInline
              className="p2pMoneyAbroadHero--video"
            >
              <source
                src="/video/home-hero-desktop.mp4"
                type="video/mp4"
                media="(min-width: 1024px)"
              />
              <source src="/video/home-hero-mobile.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};
